import ErrorReport from './ErrorReport'

export default ErrorReport
